import { render, staticRenderFns } from "./process_l.vue?vue&type=template&id=8f6c36cc&scoped=true"
import script from "./process_l.vue?vue&type=script&lang=js"
export * from "./process_l.vue?vue&type=script&lang=js"
import style0 from "./process_l.vue?vue&type=style&index=0&id=8f6c36cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6c36cc",
  null
  
)

export default component.exports